import React from 'react';
import { useTranslation } from 'react-i18next';
import useFlowInputComponent from '../../../../hooks/useFlowsInputComponent';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import MultiLineInput from '../multiline/MultiLineInput';
import NotesPopover from './NotesPopover';

interface Props {
  question: FlowsQuestion;
}

const NotesInputComponent: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  const { t } = useTranslation();

  const {
    field: { value, onBlur, onChange },
    prefilled,
    error,
  } = useFlowInputComponent({ question });

  const handleOnBlur = () => {
    onBlur({ name: question.id, value });
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleChange = (e: any) => {
    const value = e.target.value;
    onChange({ name: question.id, value });
  };

  return (
    <>
      <MultiLineInput
        name={question.id}
        onChange={handleChange}
        prefilled={prefilled}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onBlur={(e: any) => onBlur(e)}
        value={value}
        error={error}
        placeholder={t('FLOWS_INPUT-COMPONENT_NOTES_TYPE-NOTES-HERE') + '...'}
        isDisabled={question.rules.is_disabled}
      />
      {!question.rules.is_disabled && (
        <NotesPopover
          question={question}
          value={value}
          onChange={onChange}
          onBlur={handleOnBlur}
        />
      )}
    </>
  );
};

export default NotesInputComponent;
